import React, { createContext, useContext } from "react";
import styled from "styled-components";
import MapIcon from "../../icons/MapIcon";
import { ActivityContext } from "../ActivityProvider";

export const BtnContext = createContext();

export default function SideBar() {
  const [isActive, setIsActive] = useContext(ActivityContext);

  function handleClick(e) {
    const { name } = e.currentTarget;

    setIsActive(() => {
      return {
        [name]: 1,
      };
    });
  }

  return (
    <StyledWrapper>
      <StyledButton
        name={"btn-1"}
        isclicked={isActive["btn-1"]}
        onClick={handleClick}
      >
        <StyledMapIcon isclicked={isActive["btn-1"]} />
      </StyledButton>

      {/* <StyledButton
        name={"btn-2"}
        isclicked={isActive["btn-2"]}
        onClick={handleClick}
      >
        <StyledMeasureIcon isclicked={isActive["btn-2"]} />
      </StyledButton>

      <StyledButton
        name={"btn-3"}
        isclicked={isActive["btn-3"]}
        onClick={handleClick}
      >
        <StyledLayersIcon isclicked={isActive["btn-3"]} />
      </StyledButton> */}
    </StyledWrapper>
  );
}

const StyledWrapper = styled.div`
  width: 62px;
  height: 100%;
  background-color: #f2cc8f;
  box-shadow: rgba(149, 157, 165, 0.2) -2px 8px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const StyledButton = styled.button`
  width: 40px;
  height: 40px;
  background-color: ${(props) => (props.isclicked ? "#3d405b" : "white")};
  box-shadow: rgba(0, 0, 0, 0.03) 0px 1px 4px;
  border-radius: 5px;
  color: ${(props) => (props.isClicked ? "#e07a5f" : "#e07a5f")};
  display: flex;
  justify-content: center;
  margin: 10px;
  align-items: center;
  border: none;
  cursor: pointer;
`;

const StyledMapIcon = styled(MapIcon)`
  && {
    pointer-events: none;
  }
`;
